import { createStore, applyMiddleware, compose as reduxCompose } from "redux";
import thunk from 'redux-thunk'
import rootReducer from '../reducers/root'

const reduxDevtoolsAvailable = (typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
const compose = !reduxDevtoolsAvailable ? reduxCompose : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
})

const enhancer = compose(
  applyMiddleware(thunk)
  //, other store enhancers if any
)

const store = createStore(
  rootReducer,
  undefined,
  enhancer
)

export default store


// WEBPACK FOOTER //
// ./src/store/configure.js